namespace GeniuzPOS.Lookups {
    export interface PsPosShiftStatusRow {
        ShiftStatus?: string;
        ShiftStatusDesc?: string;
        FullName?: string;
    }

    export namespace PsPosShiftStatusRow {
        export const idProperty = 'ShiftStatus';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Lookups.PsPosShiftStatus';
        export const lookupKey = 'PsPosShiftStatusRow';

        export function getLookup(): Q.Lookup<PsPosShiftStatusRow> {
            return Q.getLookup<PsPosShiftStatusRow>('PsPosShiftStatusRow');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            ShiftStatus = "ShiftStatus",
            ShiftStatusDesc = "ShiftStatusDesc",
            FullName = "FullName"
        }
    }
}
